import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import CopyJobViewModel from './CopyJobViewModel'
import { observer } from 'mobx-react'
import * as React from 'react'
import Button from 'components/Button'
import { useHistory } from 'react-router'

interface CopyJobDialogProps {
  vm: CopyJobViewModel
}

/**
 * The CopyJobDialog
 */
export default observer(function CopyJobDialog({ vm }: CopyJobDialogProps) {
  const history = useHistory()
  const copyDraft = React.useCallback(async () => {
    history.push(await vm.copyJob())
  }, [vm.job, history])

  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentTitle>Clone Job</ModalSheetContentTitle>
          <ModalSheetContentDescription>
            A new request will be drafted (but not submitted) using the answers
            from this request.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button onClick={vm.close}>Cancel</Button>
          <Button
            type="primary"
            onClick={copyDraft}
            dataTest="copy-job-modal-confirm"
          >
            Clone
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
